<mat-drawer-container class="report-container">
    <mat-drawer #drawer mode="side" class="report-drawer mxs-drawer" [opened]="!filtersCollapsed" [disableClose]="true">
        <mat-toolbar class="report-toolbar mxs-drawer_toolbar">
            <mat-toolbar-row>
                <ng-container *ngFor="let button of filterButtons.getArray()">
                    <mx-button [buttonModel]="button"></mx-button>
                </ng-container>
                <ng-container *ngIf="filterButtonsTemplate">
                    <ng-container *ngTemplateOutlet="filterButtonsTemplate"></ng-container>
                </ng-container>
                <ng-container *ngTemplateOutlet="userConfigTemplate"></ng-container>
            </mat-toolbar-row>

        </mat-toolbar>
        <mx-form
                (keydown.enter)="$event.stopPropagation(); submitFilterForm()"
                (customize)="onCustomizeFilters($event)"
                class="mxs-drawer_container"></mx-form>
    </mat-drawer>
    <div class="report-content-wrapper" [ngClass]="{'filters-collapsed': filtersCollapsed}">
        <div class="report-grid-wrapper">
            <div *ngIf="reportSearchResult && reportSearchResult.message">
                {{reportSearchResult.message}}
            </div>
            <mx-grid class="mx-grid-screen"></mx-grid>
        </div>
    </div>
</mat-drawer-container>


<ng-template #userConfigTemplate>
    <mx-button style="margin-left: auto" [buttonModel]="profileButton" [matMenuTriggerFor]="menu"></mx-button>
    <mat-menu #menu="matMenu" yPosition="below" class="mxs-dropdown_list">
        <ng-container *ngFor="let config of userConfigs">
            <div mat-menu-item (click)="selectConfig(config)">
                <div style="display: flex">
                    <div style="width: 15px">
                        <mat-icon *ngIf="config.filters" class="user-config-icon">filter_alt</mat-icon>
                    </div>
                    <div style="width: 15px">
                        <mat-icon *ngIf="config.columns" class="user-config-icon">view_column_2</mat-icon>
                    </div>
                </div>
                <div class="item-text">
                    <span >{{config.name}}</span>
                </div>
                <div style="display: flex;margin: 0 5px;">
                    <mat-icon matTooltip="Update config" class="btn-icon"
                              (click)="$event.stopPropagation(); updateUserConfig(config)">save</mat-icon>
                    <mat-icon matTooltip="Remove config" class="btn-icon" style="color:red"
                              (click)="$event.stopPropagation();removeReportUserConfig(config)">clear</mat-icon>
                </div>
            </div>
        </ng-container>
        <mat-divider></mat-divider>
        <div style="display: flex;justify-content: center;"
             mat-menu-item class="save-btn" (click)="saveConfig()">
            <div> <strong>Save config</strong></div>
        </div>
    </mat-menu>
</ng-template>
